import React from 'react';
const LocalizationContext = React.createContext(null);
export default LocalizationContext;